import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProductSearchFilter } from 'src/models/DTO/filters/productSearchFilter';
import { ProductCollection } from 'src/models/DTO/products/productCollection';
import { Config } from '../../../infrastructure/config';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  // private getPortionOfItemsPerCategoryURL : string = Config.api + "product/search";
  private getPortionOfItemsPerCategoryURL : string = Config.api + "product";

  constructor(private httpClient: HttpClient) {
  }

  getFirstPortionOfProductsPerCategory(portionSize: number, category: string) {
    const params = '?fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cstate&fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&include=skus%2Corganisation%2Cpricing%2Cbrand%2Ccategory%2Cmanufacturer%2Cskus.options.option%2Coptions.option&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Borganisation%5D=id%2Cuuid%2Cname_in_latin%2Cnative_name&filter%5Bstate%5D=active&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&fields%5Bskus.options%5D=id%2Cuuid%2Csku_id%2Coption_variation_id%2Cdisplay_value&fields%5Bskus.options.option%5D=id%2Cuuid%2Cdisplay_name&fields%5Boptions.option%5D=id%2Cuuid%2Cdisplay_name&perPage=' + portionSize + '&&filter%5Bcategories%5D=' + category;
    return this.httpClient.get<ProductCollection>(this.getPortionOfItemsPerCategoryURL + params);
  }

  getAllPortionOfProductsPerCategory(perPage: number, page: number, category: string) {
    const params = '?fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cstate&fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&include=skus%2Corganisation%2Cpricing%2Cbrand%2Ccategory%2Cmanufacturer%2Cskus.options.option%2Coptions&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Borganisation%5D=id%2Cuuid%2Cname_in_latin%2Cnative_name&filter%5Bstate%5D=archived&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&fields%5Bskus.options%5D=id%2Cuuid%2Csku_id%2Coption_variation_id%2Cdisplay_value&fields%5Bskus.options.option%5D=id%2Cuuid%2Cdisplay_name"&filter%5Bstate%5D=ACTIVE&fields%5Boptions%5D=id%2Cuuid%2Cdisplay_name&perPage=' + perPage + '&page=' + page + '&filter%5Bcategory%5D=';
    return this.httpClient.get<ProductCollection>(this.getPortionOfItemsPerCategoryURL + params + category);
  }

  getAllPortionOfProductsPerPartner(perPage: number, page: number, partnerUUID: string, query: string = '') {
    const params = '?fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cstate&fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&include=skus%2Corganisation%2Cpricing%2Cbrand%2Ccategory%2Cmanufacturer&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Borganisation%5D=id%2Cuuid%2Cname_in_latin%2Cnative_name&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&filter%5Bstate%5D=active&perPage=' + perPage + '&page=' + page + '&filter%5Bpartner%5D=' + partnerUUID + '&q=' + query;
    return this.httpClient.get<ProductCollection>(this.getPortionOfItemsPerCategoryURL + params);
  }

  getAllProductsPerSearch(perPage: number, page: number, query: string = '', sorter: string = 'newest', filters: ProductSearchFilter) {
    let params = '?fields%5Bproducts%5D=id%2Cuuid%2Cname%2Corganisation_id%2Ccreated_at%2Cupdated_at%2Ccategory_id%2Cbrand_id%2Cmanufacturer_id%2Cstate&fields%5Bskus%5D=id%2Cproduct_id%2Cuuid%2Csku%2Cavailable_quantity%2Creserved_quantity&include=skus%2Corganisation%2Cpricing%2Cbrand%2Ccategory%2Cmanufacturer%2Cskus.options.option%2Coptions.option&append=total_available_quantity%2Ctotal_reserved_quantity&fields%5Borganisation%5D=id%2Cuuid%2Cname_in_latin%2Cnative_name&filter%5Bstate%5D=active&fields%5Bpricing%5D=id%2Cproduct_id%2Cuuid%2Cquantity_from%2Cquantity_to%2Cprice_per_piece&fields%5Bcategory%5D=id%2Cuuid%2Cname&fields%5Bskus.options%5D=id%2Cuuid%2Csku_id%2Coption_variation_id%2Cdisplay_value&fields%5Bskus.options.option%5D=id%2Cuuid%2Cdisplay_name&fields%5Boptions.option%5D=id%2Cuuid%2Cdisplay_name&perPage=' + perPage + '&page=' + page;
    if (query) {
      params += '&q=' + query;
    }
    filters.filters.forEach((value) => {
      if (value.key === 'options') {
        Object.keys(value.value).forEach(key => {
          const optionValues = Array.isArray(value.value[key]) ? value.value[key] : [value.value[key]];

          optionValues.forEach((optionValue: any) => {
            params += '&' + new HttpParams()
              .append(`filter[options][${key}][]`, String(optionValue))
              .toString();
          });
        });

        return;
      }

      if (Array.isArray(value.value)) {
        value.value.forEach((filterValue: any) => {
          params += '&' + new HttpParams()
            .append(`filter[${value.key}][]`, String(filterValue))
            .toString();
        });

        return;
      }

      params += '&' + new HttpParams()
        .set(`filter[${value.key}]`, String(value.value))
        .toString();
    })
    params += '&sort=' + sorter;
    return this.httpClient.get<ProductCollection>(this.getPortionOfItemsPerCategoryURL + params);
  }

}
